import { AppState } from '@/types';
import { AppAction } from '../types';
import { getGlobalWeekStart } from '@/utils/globalWeekUtils';
import { getMonthStart } from '@/utils/monthlyReset';
import { calculateWeeklyBonus } from '@/lib/weeklyBonusSystem';

export function handleUpdateWeeklyGoal(state: AppState, action: Extract<AppAction, { type: 'UPDATE_WEEKLY_GOAL' }>): AppState {
  const updatedUser = state.user ? { ...state.user, weeklyGoal: action.payload.goal } : null;
  return {
    ...state,
    weeklyGoal: action.payload.goal,
    user: updatedUser
  };
}

export function handleResetWeek(state: AppState): AppState {
  console.log('🔄 handleResetWeek called - currentWeekPoints before reset:', state.currentWeekPoints);
  console.log('🔄 handleResetWeek - state before reset:', {
    totalPoints: state.totalPoints,
    currentWeekPoints: state.currentWeekPoints,
    activitiesLoggedToday: state.activitiesLoggedToday,
    activitiesCount: state.activities.length
  });
  
  // Get baseline goal (default to 200 if not set)
  const baselineGoal = 200; // TODO: fetch from profiles.baseline_goal
  
  // Update streak based on goal achievement
  const goalAchieved = state.currentWeekPoints >= state.weeklyGoal;
  const newStreak = goalAchieved ? state.weeklyGoalStreak + 1 : 0;
  
  // Don't award bonus here anymore - it's awarded immediately when goal is reached
  // But keep the tracking for records
  const bonusResult = calculateWeeklyBonus(
    state.currentWeekPoints,
    state.weeklyGoal,
    baselineGoal
  );
  
  const newState = {
    ...state,
    currentWeekPoints: 0,
    activitiesLoggedToday: 0,
    weeklyStartDate: getGlobalWeekStart(),
    // Reset both weekly and daily stats for fresh start
    activityCounts: {
      'Closed': 0,
      'Opening': 0,
      'Set': 0,
      'Daily Quest': 0,
      'Hangout': 0,
      'Story': 0,
      'Roleplay': 0
    },
    // Update weekly bonus tracking
    weeklyGoalStreak: newStreak,
    lastWeekGoalAchieved: goalAchieved,
    weeklyBonusEarned: 0, // Reset bonus tracking for new week
    weeklyBonusAwarded: false, // Reset for new week
    weeklySummaryShown: false, // Reset for new week
    // Don't award credits here - already awarded when goal was reached
    gold: state.gold // Keep gold unchanged
  };
  
  console.log('🔄 handleResetWeek completed - new state:', {
    totalPoints: newState.totalPoints,
    currentWeekPoints: newState.currentWeekPoints,
    activitiesLoggedToday: newState.activitiesLoggedToday,
    activitiesCount: newState.activities.length
  });
  return newState;
}

export function handleResetMonth(state: AppState): AppState {
  console.log('🗓️ handleResetMonth called - currentMonthPoints before reset:', state.currentMonthPoints);
  console.log('🗓️ handleResetMonth - state before reset:', {
    totalPoints: state.totalPoints,
    currentMonthPoints: state.currentMonthPoints,
    currentWeekPoints: state.currentWeekPoints
  });
  
  const newState = {
    ...state,
    currentMonthPoints: 0,
    monthlyStartDate: getMonthStart()
  };
  
  console.log('🗓️ handleResetMonth completed - new state:', {
    totalPoints: newState.totalPoints,
    currentMonthPoints: newState.currentMonthPoints,
    currentWeekPoints: newState.currentWeekPoints
  });
  return newState;
}

export function handleMarkWeeklySummaryShown(state: AppState): AppState {
  return {
    ...state,
    weeklySummaryShown: true
  };
}